import authSelector from 'modules/Auth/selectors'
import InterviewerDashboard from 'modules/InterviewerDashboard'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  userData: authSelector.getUserData(state),
})

const mapDispatchToProps = {}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InterviewerDashboard)
